/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row, UncontrolledTooltip } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, isNumber, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getClinicalDictionaries } from 'app/entities/clinical-dictionary/clinical-dictionary.reducer';
import { getEntities as getWorkFlowProtocols } from 'app/entities/work-flow-protocol/work-flow-protocol.reducer';
import { createEntity, getEntity, reset, updateEntity } from './work-flow-protocol-log.reducer';

export const WorkFlowProtocolLogUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const clinicalDictionaries = useAppSelector(state => state.clinicalDictionary.entities);
  const workFlowProtocols = useAppSelector(state => state.workFlowProtocol.entities);
  const workFlowProtocolLogEntity = useAppSelector(state => state.workFlowProtocolLog.entity);
  const loading = useAppSelector(state => state.workFlowProtocolLog.loading);
  const updating = useAppSelector(state => state.workFlowProtocolLog.updating);
  const updateSuccess = useAppSelector(state => state.workFlowProtocolLog.updateSuccess);

  const handleClose = () => {
    navigate(`/work-flow-protocol-log${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getClinicalDictionaries({}));
    dispatch(getWorkFlowProtocols({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }
    if (values.lastUpdated !== undefined && typeof values.lastUpdated !== 'number') {
      values.lastUpdated = Number(values.lastUpdated);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.timestampEntry !== undefined && typeof values.timestampEntry !== 'number') {
      values.timestampEntry = Number(values.timestampEntry);
    }

    const entity = {
      ...workFlowProtocolLogEntity,
      ...values,
      encounterType: clinicalDictionaries.find(it => it.id.toString() === values.encounterType?.toString()),
      protocol: workFlowProtocols.find(it => it.id.toString() === values.protocol?.toString()),
      completedByType: clinicalDictionaries.find(it => it.id.toString() === values.completedByType?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          ...workFlowProtocolLogEntity,
          encounterType: workFlowProtocolLogEntity?.encounterType?.id,
          protocol: workFlowProtocolLogEntity?.protocol?.id,
          completedByType: workFlowProtocolLogEntity?.completedByType?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.workFlowProtocolLog.home.createOrEditLabel" data-cy="WorkFlowProtocolLogCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.workFlowProtocolLog.home.createOrEditLabel">
              Create or edit a WorkFlowProtocolLog
            </Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="work-flow-protocol-log-id"
                  label={translate('tinyMedicRestApp.workFlowProtocolLog.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.workFlowProtocolLog.encounterId')}
                id="work-flow-protocol-log-encounterId"
                name="encounterId"
                data-cy="encounterId"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                }}
              />
              <UncontrolledTooltip target="encounterIdLabel">
                <Translate contentKey="tinyMedicRestApp.workFlowProtocolLog.help.encounterId" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.workFlowProtocolLog.notes')}
                id="work-flow-protocol-log-notes"
                name="notes"
                data-cy="notes"
                type="text"
              />
              <UncontrolledTooltip target="notesLabel">
                <Translate contentKey="tinyMedicRestApp.workFlowProtocolLog.help.notes" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.workFlowProtocolLog.completedById')}
                id="work-flow-protocol-log-completedById"
                name="completedById"
                data-cy="completedById"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                }}
              />
              <UncontrolledTooltip target="completedByIdLabel">
                <Translate contentKey="tinyMedicRestApp.workFlowProtocolLog.help.completedById" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.workFlowProtocolLog.active')}
                id="work-flow-protocol-log-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <UncontrolledTooltip target="activeLabel">
                <Translate contentKey="tinyMedicRestApp.workFlowProtocolLog.help.active" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.workFlowProtocolLog.cursor')}
                id="work-flow-protocol-log-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <UncontrolledTooltip target="cursorLabel">
                <Translate contentKey="tinyMedicRestApp.workFlowProtocolLog.help.cursor" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.workFlowProtocolLog.lastUpdated')}
                id="work-flow-protocol-log-lastUpdated"
                name="lastUpdated"
                data-cy="lastUpdated"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <UncontrolledTooltip target="lastUpdatedLabel">
                <Translate contentKey="tinyMedicRestApp.workFlowProtocolLog.help.lastUpdated" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.workFlowProtocolLog.microSec')}
                id="work-flow-protocol-log-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <UncontrolledTooltip target="microSecLabel">
                <Translate contentKey="tinyMedicRestApp.workFlowProtocolLog.help.microSec" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.workFlowProtocolLog.timestampEntry')}
                id="work-flow-protocol-log-timestampEntry"
                name="timestampEntry"
                data-cy="timestampEntry"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <UncontrolledTooltip target="timestampEntryLabel">
                <Translate contentKey="tinyMedicRestApp.workFlowProtocolLog.help.timestampEntry" />
              </UncontrolledTooltip>
              <ValidatedField
                id="work-flow-protocol-log-encounterType"
                name="encounterType"
                data-cy="encounterType"
                label={translate('tinyMedicRestApp.workFlowProtocolLog.encounterType')}
                type="select"
              >
                <option value="" key="0" />
                {clinicalDictionaries
                  ? clinicalDictionaries.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="work-flow-protocol-log-protocol"
                name="protocol"
                data-cy="protocol"
                label={translate('tinyMedicRestApp.workFlowProtocolLog.protocol')}
                type="select"
              >
                <option value="" key="0" />
                {workFlowProtocols
                  ? workFlowProtocols.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="work-flow-protocol-log-completedByType"
                name="completedByType"
                data-cy="completedByType"
                label={translate('tinyMedicRestApp.workFlowProtocolLog.completedByType')}
                type="select"
              >
                <option value="" key="0" />
                {clinicalDictionaries
                  ? clinicalDictionaries.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/work-flow-protocol-log" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default WorkFlowProtocolLogUpdate;
